import { useNavigate } from 'react-router-dom';
import EditIcon from '../../../assets/icons/edit.svg?react';
import DeleteIcon from '../../../assets/icons/delete.svg?react';

const StationTableItem = ({idx, station, onEdit, onDelete, onStationDetail, drResourceInfo}) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    // 상세페이지로 이동
    navigate(`./detail/${station.StationSysId}`, { state: { from: 'list' } });
  };

  /*
  ChargerSysId	Guid	충전기관리를 위한 시스템 식별자		
  PowerMeterContractNumber	string	계량기 계약 번호	Y	포인트.. 
  CpoStationId	string	충전사업자가 지정한 충전소 식별자	Y	
  CpoChargerId	string	충전사업자가 지정한 충전기 식별자	Y	
  CpoName	string	충전사업자 이름	Y	
  CpoId	string	충전사업의 고유 식별자	Y	
  Capacity	int	충전기 용량	Y	
  Address	string	충전기 설치 주소	Y	
  Lat	double	충전기 설치 위도값	상세(지도)	
  Lng	double	충전기 설치 경도값	상세(지도)	
  Chargers	ICollection	충전기 목록	상세	
  DrResouceSysId	Guid	할당된 DR자원의 시스템 식별자		
  */

  return (
    <tr className='primary-table-item-clickable' onClick={handleRowClick}>
      <td className="station-idx">{idx}</td>
      <td className={`station-dr-resource ${drResourceInfo ? "" : "no-assigned"}`}>{drResourceInfo ? drResourceInfo.ResourceName : "미할당"}</td>
      <td className="station-station-name">{station.CpoStationName || "-"}</td>
      <td className="station-station-id">{station.CpoStationId || "-"}</td>
      <td className="station-address">{station.Address || "-"}</td>
      <td className="station-cpo-name">{station.CpoName || "-"}</td>
      <td className="station-cpo-id">{station.CpoId || "-"}</td>
      <td className="station-contract">{station.PowerMeterContractNumber || "-"}</td>
      <td className='button-container' onClick={(e) => e.stopPropagation()}>
        <div className='flex align-center gap-5'>
          <button className='btn icon-btn' onClick={(e) => {e.stopPropagation(); onEdit(station)}}>
            <EditIcon color='var(--gray-600)'/>
          </button>
          <button className='btn icon-btn' onClick={(e) => {e.stopPropagation(); onDelete(station)}}>
            <DeleteIcon color='var(--gray-600)'/>
          </button>
        </div>
      </td>
    </tr>
  )
}

export default StationTableItem